<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.service_provider_update_details") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #072e68">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        
        <div class="row">

          <!-- <h2>
            {{ $t("PLACEHOLDERS.providerData") }}
          </h2> -->

          <!-- Start:: Ar Name Input -->
          <!-- <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.provider_name')"
            v-model.trim="data.provider_name"
            disabled
          /> -->
          <!-- <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.phone')"
            v-model.trim="data.phone"
            disabled
          /> -->
          <!-- End:: Ar Name Input -->
          <!-- <h2>
            {{ $t("PLACEHOLDERS.shopData") }}
          </h2> -->
          <!-- Start:: En Name Input -->
          <base-image-upload-input
            col="12"
            identifier="service_image"
            :placeholder="$t('PLACEHOLDERS.logo')"
            :preSelectedImage="data.logo"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.shop_name')"
            v-model.trim="data.shop_name"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.shop_mobile')"
            v-model.trim="data.shop_mobile"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.email')"
            v-model.trim="data.email"
            disabled
          />
          <base-image-upload-input
            col="12"
            identifier="service_image"
            :placeholder="$t('PLACEHOLDERS.commercial_register_image')"
            :preSelectedImage="data.commercial_register_image"
            disabled
          />
          <base-input
            col="12"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.desc')"
            v-model.trim="data.desc"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.main_section')"
            v-model.trim="data.mainC"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.sub_section')"
            v-model.trim="data.subC"
            disabled
          />


          <h2>
            {{ $t("PLACEHOLDERS.storeLocation") }}
          </h2>
          <div class="map_wrapper">
            <GmapMap
              :center="{
                lat: parseFloat(data.lat),
                lng: parseFloat(data.lng),
              }"
              :zoom="13"
              map-type-id="terrain"
              style="width: 100%; height: 500px"
            >
              <GmapMarker
                :key="index"
                v-for="(m, index) in markers"
                :position="m.position"
                :clickable="false"
                :draggable="false"
                @click="center = m.position"
              />
            </GmapMap>
          </div>

          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.municipality')"
            v-model.trim="data.state"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.area')"
            v-model.trim="data.city"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.district')"
            v-model.trim="data.district"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.storeLocation')"
            v-model.trim="data.storeLocation"
            disabled
          />

          <!-- End:: count_stores Input -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import UploadsPhotos from "../../../components/formInputs/UploadsPhotos.vue";

export default {
  name: "CreateArea",
  components: {
    UploadsPhotos,
  },
  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        provider_name: null,
        phone: null,
        logo: null,
        shop_name: null,
        shop_mobile: null,
        email: null,
        commercial_register_image: null,
        desc: null,
        mainC: null,
        subC: null,
        state: null,
        city: null,
        lat: null,
        lng: null,
        district: null,
        storeLocation: null,
        street: null,
        twoer: true,
        vehicle_license_image_face: true,
        vehicle_license_image_back: true,
        work_hours: [],
      },
      additionalImages: [],
      imgUrls: [],
      markers: [],

      // End:: Data Collection To Send
    };
  },

  methods: {
    getDay(id) {
      if (id == 1) {
        return this.$t("PLACEHOLDERS.1");
      }
      if (id == 2) {
        return this.$t("PLACEHOLDERS.2");
      }
      if (id == 3) {
        return this.$t("PLACEHOLDERS.3");
      }
      if (id == 4) {
        return this.$t("PLACEHOLDERS.4");
      }
      if (id == 5) {
        return this.$t("PLACEHOLDERS.5");
      }
      if (id == 6) {
        return this.$t("PLACEHOLDERS.6");
      }
      if (id == 7) {
        return this.$t("PLACEHOLDERS.7");
      }
    },
    onFileSelect(files) {
      this.additionalImages = files;
    },
    async onFileRemove(index) {
      this.$delete(this.imgUrls, index);

      const imageId = this.imageId[index];
      try {
        await this.$axios({
          method: "GET",
          url: `delete-file/${imageId}`,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.deletedSuccessfully"));
        this.$delete(this.imgUrls, index);
      } catch (error) {
        this.isWaitingRequest = false;
        // Handle error as needed
        this.$message.error(error.response.data.message);
      }
    },
    // Start:: Get Data To Edit
    async getDataToEdit() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `modify_provider_join_requests/${this.$route.params.id}`,
        });
        // Start:: Set Data
        this.data.provider_name = res.data.data.JoinRequest.name;
        this.data.phone = res.data.data.JoinRequest.mobile;
        this.data.logo = res.data.data.JoinRequest.logo_path;
        this.data.shop_name = res.data.data.JoinRequest.store_name;
        this.data.shop_mobile = res.data.data.JoinRequest.store_mobile;
        this.data.email = res.data.data.JoinRequest.email;
        this.data.commercial_register_image = res.data.data.JoinRequest.commercial_register_path;
        this.data.desc = res.data.data.JoinRequest.description;
        this.data.mainC =
          res.data.data.JoinRequest.section?.name;
        this.data.subC =
          res.data.data.JoinRequest.sub_section?.name;
        this.data.state = res.data.data.JoinRequest.state?.name;
        this.data.city = res.data.data.JoinRequest.region?.name;
        this.data.district = res.data.data.JoinRequest.district?.name;
        this.data.storeLocation = res.data.data.JoinRequest.address;
        this.data.lat = res.data.data.JoinRequest.latitude;
        this.data.lng = res.data.data.JoinRequest.longitude;
        (this.markers = [
          {
            id: 1,
            position: {
              lat: parseFloat(res.data.data.JoinRequest.latitude),
              lng: parseFloat(res.data.data.JoinRequest.longitude),
            },
          },
        ])
        // End:: Set Data
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
  },

  async created() {
    // Start:: Fire Methods
    this.getDataToEdit();
    // End:: Fire Methods
  },
};
</script>
<style>
.preview-container img {
  max-width: 100%;
  max-height: 200px;
  border: 1px solid #ccc;
  border-radius: 15px;
}
</style>
